import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MydiaryService } from 'src/app/services/mydiary.service';
import { UserDetailsCommon } from '../user-details.common';
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { HumanResourceService } from 'src/app/services/human-resource.service';

@Component({
  selector: 'app-my-leaves',
  templateUrl: './my-leaves.component.html',
  styleUrls: ['./my-leaves.component.css'],
})
export class MyLeavesComponent implements OnInit {
  reportingPartnerId: any;
  modalStatus: any;
  selectedFY: any = null;
  financialYearList: any;
  modalForm;
  userBalanceLeaves: any;
  formSubmitted = false;
  formErrors = UserDetailsCommon.leaveFormErrors;
  formValidationMessages = UserDetailsCommon.leaveFormValidationMessages;
  approverList: any;
  leaveTypeList: any;
  leaveSummaryList: any;
  appliedLeaveList: any;
  userJoiningDate;
  hideLeaveType;
  newLeaveTypeList;
  formatDate;
  userRole;
  userType;
  userId;
  userICAIRegistrationDate;
  articleshipTenureResponse;

  @ViewChild('modalContent') private modalContent;

  constructor(
    private modalService: NgbModal,
    private mydiaryService: MydiaryService,
    private masterDataService: MasterDataService,
    private fb: FormBuilder,
    private commonMessageService:CommonMessageService,
    private humanResourceService: HumanResourceService
  ) {
    const current = new Date();
    var lastDay = new Date(current.getFullYear(), current.getMonth() + 1, 0);
    this.formatDate = {
      year: lastDay.getFullYear(),
      month: lastDay.getMonth() + 1,
      day: lastDay.getDate()
    };
    console.log('formated date', this.formatDate);
   }

  ngOnInit(): void {
    this.userRole=localStorage.getItem('userRole');
    this.userType=localStorage.getItem('userType');
    this.userId=localStorage.getItem('id');
    this.userICAIRegistrationDate=localStorage.getItem('userICAIRegistrationDate');
    this.articleshipTenureResponse=null;
    console.log('userRole',this.userRole);
        if (localStorage.getItem('userDesignation') == 'Partner' || localStorage.getItem('userDesignation') == 'Manager') {
      this.hideLeaveType = true;
      console.log('this.hideLeaveType', this.hideLeaveType);
    } else {
      this.hideLeaveType = false;
      console.log('else this.hideLeaveType', this.hideLeaveType);

    }
    this.reportingPartnerId = localStorage.getItem('reportingPartnerId');
    if(this.userType=='Article')
    {
      this.loadArticleTenure();
    }
    this.loadFinancialYear();
    this.initModalForm();
    this.loadBalabeLeaves();
    this.loadUserDetails();
    // this.loadLeaveSummaryForFY();
    
  }

  loadUserDetails() {
    this.masterDataService.getUserProfile().subscribe((res: any) => {
      console.log(res);
      if (res.userOfficialDetails != null) {
        var joiningDate = new Date(res.userOfficialDetails.joiningDate);
        this.userJoiningDate = {
          year: joiningDate.getFullYear(),
          month: joiningDate.getMonth() + 1,
          day: joiningDate.getDate(),
        };
        console.log('user joining date', this.userJoiningDate);
      }
    });
  }

  openModal(status) {
    this.modalStatus = status;
    const approverIndex = this.approverList.findIndex(
      (item) => item.id == this.reportingPartnerId
    );
    this.modalForm.controls.approver.setValue(this.approverList[approverIndex]);
    this.modalService
      .open(this.modalContent, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'md',
        windowClass: 'animate__animated animate__slideInUp animate__faster',
      })
      .result.then(
        (result) => { },
        (reason) => { }
      );
  }

  closeModal() {
    this.modalService.dismissAll();
    this.resetModalForm();
  }

  resetModalForm() {
    this.formSubmitted = false;
    this.modalForm.reset();
  }

  loadFinancialYear() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      console.log(res);
      this.financialYearList = res;
      this.loadApproversList();
    });
  }

  loadApproversList() {
    this.mydiaryService.getApprovers().subscribe((res) => {
      console.log(res);
      this.approverList = res;
      console.log('inLoadApp', localStorage.getItem('droles'));
      if (['Partner', 'Managing Partner', 'Designated Partner'].includes(localStorage.getItem('userRole'))) {
        this.approverList = [];
      } else {
        this.approverList = res;
      }
      this.loadLeaveType();
    });
  }

loadArticleTenure(){
  this.humanResourceService.getArticleshipTenure(this.userICAIRegistrationDate)
    .subscribe((res: any) => {
       console.log('tenure response:',res);
       if(res)
       {
        this.articleshipTenureResponse=res.tenureYears;
       }
       else{
        this.articleshipTenureResponse=null;
       }
       
  
      });
}


  loadLeaveType() {
    this.mydiaryService.getLeaveType().subscribe((res) => {
      console.log(res);
      this.leaveTypeList = res;
      console.log('leave list', this.leaveTypeList);

      if (localStorage.getItem('userDesignation') == 'Partner' ||
        localStorage.getItem('userDesignation') == 'Manager' ||
        localStorage.getItem('userDesignation') == 'HR Manager' ||
        localStorage.getItem('userDesignation') == 'HR Executive' ||
        localStorage.getItem('userDesignation') == 'Director' ||
        localStorage.getItem('userDesignation') == 'Principal') {
        const roleIndex = this.leaveTypeList.findIndex(
          (item) => item.name == 'Actual CA exam days'
        );
        this.leaveTypeList.splice(roleIndex, 1);
      }

      if (this.articleshipTenureResponse !== null && this.userId!=1386) {
        // Remove items from leaveTypeList that don't match the condition
        this.leaveTypeList = this.leaveTypeList.filter(leaveType => leaveType.name === 'Casual leave(sick or other personal)');
      } 
      // var max = this.financialYearList.reduce(function(prev, current) {
      //   if (+current.id > +prev.id) {
      //       return current;
      //   } else {
      //       return prev;
      //   }
      // });
      // this.selectedFY = max;
      var fyIndex = -1;
      this.financialYearList.forEach((element, key) => {
        var startDate = new Date(element.startDate);
        var endDate = new Date(element.endDate);
        // var currentDate = new Date();
        var currentDate = moment(new Date()).format('YYYY-MM-DD');
        console.log(startDate, endDate);
        console.log(currentDate);
        if (
          currentDate >= element.startDate &&
          currentDate <= element.endDate
        ) {
          fyIndex = key;
        }
      });
      this.selectedFY = this.financialYearList[fyIndex];
      this.loadLeaveSummaryForFY();
    });
  }

  loadLeaveSummaryForFY() {
    this.mydiaryService
      .getLeaveSummaryForFy(this.selectedFY.id)
      .subscribe((res) => {
        console.log(res);
        this.leaveSummaryList = res;
        this.loadAppliedLeavesForLoggedinUser(this.selectedFY.id);
      });
  }

  loadAppliedLeavesForLoggedinUser(id) {
    this.mydiaryService.getAppliedLeavesForLoggedinUser(id).subscribe((res) => {
      console.log(res);
      this.appliedLeaveList = res;
      console.log('Approver Name', this.appliedLeaveList);
    });
  }

  // loadPendingLeaveApproval() {
  // this.mydiaryService.getPendingLeaveApprovals()
  // .subscribe(res => {
  //   console.log(res);
  //   this.pendingLeaveApprovalList = res;
  // });
  // }

  // Initialize Form
  initModalForm() {
    this.modalForm = this.fb.group({
      id: [''],
      approver: [null],
      reason: [null, [Validators.required]],
      fromDate: ['', [Validators.required]],
      toDate: [null, [Validators.required]],
      leaveDays: ['', [Validators.required]],
      leaveType: [null, [Validators.required]],
    });
  }

  getJsonFromModal() {
    var fromDate = moment({
      year: this.modalForm.getRawValue().fromDate.year,
      month: this.modalForm.getRawValue().fromDate.month - 1, // Months are 0-based
      day: this.modalForm.getRawValue().fromDate.day
    }).format("YYYY-MM-DD");
  
    var toDate = moment({
      year: this.modalForm.getRawValue().toDate.year,
      month: this.modalForm.getRawValue().toDate.month - 1, // Months are 0-based
      day: this.modalForm.getRawValue().toDate.day
    }).format("YYYY-MM-DD");
  
    var jsonData = { ...this.modalForm.value };
    jsonData.fromDate = fromDate;
    jsonData.toDate = toDate;
  
    return JSON.stringify(jsonData);
  }
  

  onSubmitLeaveRequest() {
    console.log('leave data before save', this.modalForm);
    this.formSubmitted = true;
    this.logValidationErrors(this.modalForm);
    if (this.modalForm.valid) {
      this.mydiaryService
        .submitLeave(this.getJsonFromModal())
        .subscribe((resp) => {
          console.log(resp);
          this.loadBalabeLeaves();
          this.changeModalFormObjList(resp);
          this.closeModal();
          this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
          this.loadLeaveSummaryForFY();
        });

    }
  }

  changeModalFormObjList(modalFormObj) {
    this.appliedLeaveList.push(modalFormObj);
  }

  onToDateChange() {
    const fromDate = moment({
      year: this.modalForm.value.fromDate.year,
      month: this.modalForm.value.fromDate.month - 1, // Months are 0-based in moment.js
      day: this.modalForm.value.fromDate.day
    });
  
    const toDate = moment({
      year: this.modalForm.value.toDate.year,
      month: this.modalForm.value.toDate.month - 1,
      day: this.modalForm.value.toDate.day
    });
  
    console.log('fromDate', fromDate.format('YYYY-MM-DD'));
    console.log('toDate', toDate.format('YYYY-MM-DD'));
  
    if (!fromDate.isValid() || !toDate.isValid()) {
      console.error('Invalid date detected');
      return;
    }
  
    const leaveDays = toDate.diff(fromDate, 'days') + 1;
  
    console.log('leaveDays', leaveDays);
    this.modalForm.controls.leaveDays.setValue(leaveDays);
  }
  
  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        // console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            // console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  loadBalabeLeaves() {
    this.mydiaryService.getBalanceLeavesOfUsers().subscribe((res) => {
      console.log(res);
      this.userBalanceLeaves = res;
      console.log('userBalanceLeaves :', this.userBalanceLeaves);
    });
  }
}
